import React, { memo } from 'react'
import { SubscriptionPlans } from '@pff-consumer/schema'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'

import { CheckoutSummaryProps } from './checkout-summary.props'
import { useStyles } from './checkout-summary.styles'

const { usePromoCode } = checkoutHooks
export const CheckoutSummary = memo((props: CheckoutSummaryProps) => {
  const { selectedPlan, price, isDiscountApplied, showKitRow } = props
  const coupon = usePromoCode()
  const styles = useStyles()
  const isAnnualPlanSelected = selectedPlan === SubscriptionPlans.PREMIUM_ANNUAL
  const currency = price.currency.symbol
  const discount = price.now.discount
  const planDescription = isAnnualPlanSelected ? 'PFF+ Annual' : 'PFF+ Monthly'
  const originalPrice = isAnnualPlanSelected ? price.now.plan : price.now.plan

  const { total: totalPrice, plan: currentPrice } = price.now
  const formattedCurrentPrice = `${currency}${currentPrice}`
  const formattedTotalPrice = `${currency}${totalPrice}`
  const formattedSetupFee = price.now.setup_fee !== '0.00' ? `${currency}${price.now.setup_fee}` : 'FREE'
  const discountPercentage = `- ${Math.round((Number(discount) / Number(originalPrice)) * 100)}%`

  return (
    <section className={styles.container}>
      <div className={styles.checkoutSummaryRow}>
        <div
          className={styles.checkoutSummaryDescription}
          data-testid='checkout.summary.planDescription'
        >
          {planDescription}
        </div>
        <div
          className={styles.checkoutSummaryPrice}
          data-testid='checkout.summary.currentPrice'
        >
          {formattedCurrentPrice}
        </div>
      </div>
      {showKitRow ? (
        <div className={styles.checkoutSummaryRow}>
          <div
            className={styles.checkoutSummaryDescription}
            data-testid='checkout.summary.draftKitFee'
          >
            Season Pass
          </div>
          <div
            className={styles.checkoutSummaryPrice}
            data-testid='checkout.summary.draftKitSetupFee'
          >
            {formattedSetupFee}
          </div>
        </div>
      ) : null}
      {isDiscountApplied && originalPrice !== totalPrice ? (
        <div className={styles.checkoutSummaryRow}>
          <div
            className={styles.checkoutSummaryDescription}
            data-testid='checkout.summary.discountCoupon'
          >
            Discount:<span className={styles.coupon}>{coupon}</span>
          </div>
          <div
            className={styles.checkoutSummaryPrice}
            data-testid='checkout.summary.discountPercentage'
          >
            {discountPercentage}
          </div>
        </div>
      ) : null}
      <div className={`${styles.checkoutSummaryRow} ${styles.finalPriceContainer}`}>
        <div className={styles.checkoutSummaryDescription}>Total</div>
        <div
          className={styles.checkoutSummaryPrice}
          data-testid='checkout.summary.totalPrice'
        >
          {formattedTotalPrice}
        </div>
      </div>
    </section>
  )
})
